/* eslint-disable no-undef */
import { useEffect, useState } from 'preact/hooks';

import { breakpoints } from '../styles';

interface DeviceState {
  isDesktop: boolean;
  isIE: boolean;
  isLandscape: boolean;
  isMobile: boolean;
  isMobileExtraSmall: boolean;
  isMobileSmall: boolean;
  isPortrait: boolean;
}

const getCurrentState = (): DeviceState => {
  const isDesktop = breakpoints.md < window.innerWidth;
  const isIE = window.navigator.userAgent.indexOf('MSIE ') > 0 || window.navigator.userAgent.indexOf('Trident/') > 0;
  const isLandscape = window.matchMedia('all and (orientation:landscape)').matches;
  const isMobile = breakpoints.md >= window.innerWidth || breakpoints.md >= window.innerHeight;
  const isMobileExtraSmall = breakpoints.xs >= window.innerWidth || breakpoints.xs >= window.innerHeight;
  const isMobileSmall = breakpoints.sm >= window.innerWidth || breakpoints.sm >= window.innerHeight;
  const isPortrait = window.matchMedia('all and (orientation:portrait)').matches;

  return {
    isDesktop,
    isIE,
    isLandscape,
    isMobile,
    isMobileExtraSmall,
    isMobileSmall,
    isPortrait,
  };
};

export const useDeviceState = (): DeviceState => {
  const [deviceState, setDeviceState] = useState<DeviceState>(getCurrentState());

  useEffect(() => {
    const handleResize = (): void => {
      setDeviceState(getCurrentState());
    };

    window.addEventListener('resize', handleResize, true);

    return (): void => {
      window.removeEventListener('resize', handleResize, true);
    };
  }, []);

  return deviceState;
};
